import {IFiltersFormValues} from "../../property/components/PropertyListFiltersModal";

export const transformMapFilterValues = (values: IFiltersFormValues | undefined) => {
    if (!values) {
        return undefined;
    }
    const floorChoicesMap: {[index: number]: boolean} = {
        1: values.floorGround,
        2: values.floorGroundWithGarden,
        3: values.floorOneToFour,
        4: values.floorFivePlus,
        5: values.floorLast,
        6: values.floorLastWithTerrace
    };

    const floorChoices = Object.keys(floorChoicesMap)
        .filter((floorChoice) => Boolean(floorChoicesMap[parseInt(floorChoice)]))
        .map((floorChoice) => parseInt(floorChoice));

    return {
        ...(values.area?.lower && {area_0: values.area.lower}),
        ...(values.area?.upper && {area_1: values.area.upper}),
        ...(values.rooms?.lower && {rooms_0: values.rooms.lower}),
        ...(values.rooms?.upper && {rooms_1: values.rooms.upper}),
        floor_choices: floorChoices
    };
};
import {IFiltersFormValues} from "../../property/components/PropertyListFiltersModal";

export const transformMapFilterValues = (values: IFiltersFormValues | undefined) => {
    if (!values) {
        return undefined;
    }
    const floorChoicesMap: {[index: number]: boolean} = {
        1: values.floorGround,
        2: values.floorGroundWithGarden,
        3: values.floorOneToFour,
        4: values.floorFivePlus,
        5: values.floorLast,
        6: values.floorLastWithTerrace
    };

    const floorChoices = Object.keys(floorChoicesMap)
        .filter((floorChoice) => Boolean(floorChoicesMap[parseInt(floorChoice)]))
        .map((floorChoice) => parseInt(floorChoice));

    return {
        ...(values.area?.lower && {area_0: values.area.lower}),
        ...(values.area?.upper && {area_1: values.area.upper}),
        ...(values.rooms?.lower && {rooms_0: values.rooms.lower}),
        ...(values.rooms?.upper && {rooms_1: values.rooms.upper}),
        floor_choices: floorChoices
    };
};
